import { cn } from '@/lib/cn.js';

const VARIANTS = {
  primary: 'bg-slate-900 text-white hover:bg-slate-800 disabled:hover:bg-slate-900 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-slate-200 dark:disabled:hover:bg-slate-100',
  secondary: 'border border-slate-300 bg-white text-slate-700 hover:bg-slate-50 disabled:hover:bg-white dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800 dark:disabled:hover:bg-slate-900',
  ghost: 'text-slate-600 hover:bg-slate-100 disabled:hover:bg-transparent dark:text-slate-300 dark:hover:bg-slate-800',
  danger: 'border border-red-200 bg-white text-red-600 hover:bg-red-50 disabled:hover:bg-white dark:border-red-500/30 dark:bg-slate-900 dark:text-red-300 dark:hover:bg-red-500/15 dark:disabled:hover:bg-slate-900',
};

const SIZES = {
  sm: 'px-2.5 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
};

/**
 * Minimal button primitive — same visual language as Dialog.Trigger.
 * `type` defaults to "button" so form dialogs don't submit by accident.
 */
export function Button({ variant = 'primary', size = 'md', type = 'button', className, ...props }) {
  return (
    <button
      type={type}
      className={cn(
        'inline-flex items-center justify-center gap-1.5 rounded-md font-medium',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-900 dark:focus-visible:outline-slate-100',
        'disabled:cursor-not-allowed disabled:opacity-50',
        VARIANTS[variant],
        SIZES[size],
        className,
      )}
      {...props}
    />
  );
}
